import { render, staticRenderFns } from "./AdministratorsDetailComponent.vue?vue&type=template&id=707b8da2&scoped=true&"
import script from "./AdministratorsDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AdministratorsDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b8da2",
  null
  
)

export default component.exports